import { useCopilotAction } from '@copilotkit/react-core'

import { F0ActionItem } from '@factorialco/f0-react'
import type { OrchestratorThinkingResult } from '@factorialco/f0-react'

/**
 * Display the orchestrator's thinking process as a non-blocking row in the chat.
 * Driven by a backend-emitted frontend tool.
 */
export const useOrchestratorThinkingAction = () => {
  useCopilotAction({
    name: 'orchestratorThinking',
    description: 'Display orchestrator thinking process (non-blocking)',
    parameters: [
      {
        name: 'message',
        description: 'User-friendly progress message',
        required: true,
      },
    ],
    available: 'frontend',
    render: (props) => {
      const title: string = props.args.message ?? 'thinking'
      const result: OrchestratorThinkingResult | undefined = props.result
      // CopilotKit v1.51+ passes "inProgress" for frontend-only actions; map to
      // "executing" to keep the spinner instead of an empty state.
      const status =
        props.status === 'complete'
          ? 'completed'
          : props.status === 'inProgress'
            ? 'executing'
            : props.status
      return <F0ActionItem title={title} status={status} inGroup={result?.inGroup} />
    },
  })
}
